import { map, reduce, isEmpty } from 'underscore';

export const validateLocation = location => (
  !isEmpty(location)
);

export const validateGeoLocation = geoLocationInfo => (
  !isEmpty(geoLocationInfo) && !geoLocationInfo.isFallbackLoc
);

export const validateHours = (hours) => {
  const daysValid = map(hours, day => (
    day.isValid === true
  ));
  return reduce(daysValid, (day, allValid) => (day && allValid), true);
};
